import { Menu as Menu$1 } from './src/Menu.js';
import { MenuItem } from './src/MenuItem.js';
import { MenuItemGroup } from './src/MenuItemGroup.js';

const Menu = Menu$1;
Menu.Item = MenuItem;
Menu.ItemGroup = MenuItemGroup;

export { Menu };
//# sourceMappingURL=index.js.map
